var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07408 9.04562C4.92769 9.18703 5.00498 9.37108 5.24671 9.45671C5.32667 9.48504 5.41836 9.50001 5.51183 9.5H10.4881C10.7707 9.50006 10.9999 9.36609 11 9.20077C11 9.146 10.9744 9.09228 10.9258 9.04545L8.4377 6.64438C8.29136 6.50295 7.97675 6.4577 7.73498 6.5433C7.66427 6.56833 7.60498 6.60302 7.56218 6.64438L5.07408 9.04562Z",
    fill: "#727293"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9259 14.9544C11.0723 14.813 10.995 14.6289 10.7533 14.5433C10.6733 14.515 10.5816 14.5 10.4882 14.5L5.51191 14.5C5.22927 14.4999 5.0001 14.6339 5 14.7992C4.99997 14.854 5.02562 14.9077 5.07418 14.9546L7.5623 17.3556C7.70864 17.497 8.02325 17.5423 8.26502 17.4567C8.33573 17.4317 8.39502 17.397 8.43782 17.3556L10.9259 14.9544Z",
    fill: "#727293"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/Arrows.9cac2b20021eae649799cce53650596e.svg";
export { ForwardRef as ReactComponent };